export default {
  en: {
    title: 'Upgrade to Erbij Plus'
  },
  nl: {
    title: 'Upgrade naar Erbij Plus'
  }
}
